module.exports = __webpack_public_path__ + "images/d4dde44d536f774dbf817feef48ef3fe.svg";